import { render, staticRenderFns } from "./GroupedLogsPerTask.vue?vue&type=template&id=6cc8217a&scoped=true"
import script from "./GroupedLogsPerTask.vue?vue&type=script&lang=js"
export * from "./GroupedLogsPerTask.vue?vue&type=script&lang=js"
import style0 from "./GroupedLogsPerTask.vue?vue&type=style&index=0&id=6cc8217a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8217a",
  null
  
)

export default component.exports